// extracted by mini-css-extract-plugin
export default {"wrapper":"index__wrapper--11Ntm","error":"index__error--37wkb","error_fix":"index__error_fix--1pEzE","error_input":"index__error_input--1USAB"};